import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlansList = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [planss, setPlanss] = useState([]);
  const [partner, setPartner] = useState(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  // ---- Pool Allocation state ----
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [allocatePlan, setAllocatePlan] = useState(null);
  const [allocateForm, setAllocateForm] = useState({
    targetPartnerCode: '',
    allocatedQuantity: '',
    allocationExpiryDate: '',
    allocationNotes: '',
  });
  const [allocateErrors, setAllocateErrors] = useState({});
  const [allocating, setAllocating] = useState(false);
  const [allocateSuccess, setAllocateSuccess] = useState(false);

    useEffect(() => {
      const fetchPartnerDetails = async () => {
        try {
          const token = localStorage.getItem('token'); // Replace with your actual token key
  
          const response = await axios.get(`${apiUrl}ESIMGOAdmin/partner_details?flag=1`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.isSuccess) {
            const partnerCode = localStorage.getItem('selectedPartnerCode');
            const foundPartner = response.data.partnerlist.find(partner => partner.partnercode === partnerCode);
            setPartner(foundPartner);
          } else {
            setError('Failed to fetch partner details');
          }
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };
  
      fetchPartnerDetails();
    }, []);
  useEffect(() => {
    const fetchPlans = async () => {
      const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
      const selectedVendor = localStorage.getItem('selectedVendor');

      try {
        const response = await fetch(`${apiUrl}ESIM/Get_all_plans?flag=2&PartnerCode=${selectedPartnerCode}&vendor_id=${selectedVendor}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.isSuccess) {
          setPlans(data.getallplan);
        } else {
          setError('Failed to fetch data');
        }
      } catch (error) {
        setError('An error occurred while fetching the plans');
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [token]);

  const handleOpenModal = (plan) => {
    setSelectedPlan(plan);
    setNewPrice(plan.sellingcost); // Set the default price to current selling cost
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPlan(null);
    setNewPrice('');
  };

  const handleActionPlan = async (flag, planid) => {
    const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
    const partnerCode = localStorage.getItem('partnerCode');
    const selectedVendor = localStorage.getItem('selectedVendor');
  
    // If price is being updated, check if the new price is valid and not too low
    if (flag === 2) {
        if (!newPrice || isNaN(newPrice)) {
            setError('Please enter a valid price');
            return;
        }
        
        // Fetch the buying cost for the selected plan
        const buyingCost = parseFloat(selectedPlan.buying_cost);
        const enteredPrice = parseFloat(newPrice);
        
        if (enteredPrice < buyingCost) {
            alert('Price is too low. Cannot set a price lower than the buying cost.');
            return;
        }
    }
  
    const planData = {
        flag: flag, // Use flag 2 for price update, flag 1 for inactivation
        partnercode: selectedPartnerCode,
        plan_id: flag === 1 ? planid : selectedPlan.planid, // For removing, use passed planid
        vendor_id: selectedVendor,
        price: flag === 2 ? newPrice : '', // Only include price if flag is 2
        updatedby: partnerCode,
    };
  
    try {
        const response = await fetch(`${apiUrl}ESIMGOAdmin/Update_plan_status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(planData),
        });
  
        const result = await response.json();
  
        if (result.isSuccess) {
            if (flag === 2) {
                // If price was updated, update the price in the plan list
                setPlans((prevPlans) => prevPlans.map((plan) =>
                    plan.planid === selectedPlan.planid ? { ...plan, sellingcost: newPrice } : plan
                ));
            }
            handleCloseModal();
            alert(flag === 2 ? 'Price updated successfully!' : 'Plan Hidden Successfully!');
        } else {
            setError('Failed to update the plan');
            alert('Failed to update the plan!');
        }
    } catch (error) {
        setError('An error occurred while updating the plan');
        alert('An error occurred while updating the plan!');
    }
};

  useEffect(() => {
    // Fetch the plans data from the API
    const fetchPlanss = async () => {
      const token = localStorage.getItem('token'); // Retrieve the token from localStorage
      const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
      const selectedVendor = localStorage.getItem('selectedVendor');
      const url = `${apiUrl}ESIMGOAdmin/view_plans_remove_price?flag=2&partnerCode=${selectedPartnerCode}&vendorId=${selectedVendor}`;
      
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`, // Attach the token to the headers
          },
        });

        const data = await response.json();
        if (data.isSuccess) {
          setPlanss(data.mappedplanlist);
        } else {
          setError("Failed to fetch data");
        }
      } catch (error) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchPlanss();
  }, []);

  const handledelete = async (id) => {
    setLoading(true); // Set loading to true while waiting for the API response

    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
    const url = `${apiUrl}ESIMGOAdmin/delete_mapped_plans`;

    try {
        const response = await fetch(url, {
            method: 'POST', // or 'DELETE' depending on the API's requirement
            headers: {
                'Authorization': `Bearer ${token}`, // Add token in Authorization header
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                flag: 1, // Delete action flag
                id: id // Pass the dynamic ID
            }),
        });

        const data = await response.json();
        
        // Check the response and show the message
        if (data.isSuccess) {
            alert(data.message);
        } else {
            alert('Something went wrong, please try again!');
        }
    } catch (error) {
        console.error('Error:', error);
        alert('There was an error with the request!');
    } finally {
        setLoading(false); // Set loading to false after the request completes
    }
};

  // ---- Pool Allocation handlers ----

  const handleOpenAllocateModal = (plan) => {
    setAllocatePlan(plan);
    setAllocateForm({
      targetPartnerCode: '',
      allocatedQuantity: '',
      allocationExpiryDate: '',
      allocationNotes: '',
    });
    setAllocateErrors({});
    setAllocateSuccess(false);
    setShowAllocateModal(true);
  };

  const handleCloseAllocateModal = () => {
    if (allocating) return; // don't let them close mid-request
    setShowAllocateModal(false);
    setAllocatePlan(null);
    setAllocateErrors({});
    setAllocateSuccess(false);
  };

  const handleAllocateFieldChange = (field, value) => {
    setAllocateForm((prev) => ({ ...prev, [field]: value }));
    setAllocateErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validateAllocateForm = () => {
    const errors = {};
    if (!allocateForm.targetPartnerCode || isNaN(allocateForm.targetPartnerCode)) {
      errors.targetPartnerCode = 'Enter a valid partner code';
    }
    if (
      !allocateForm.allocatedQuantity ||
      isNaN(allocateForm.allocatedQuantity) ||
      Number(allocateForm.allocatedQuantity) <= 0
    ) {
      errors.allocatedQuantity = 'Enter a quantity greater than 0';
    }
    if (!allocateForm.allocationExpiryDate) {
      errors.allocationExpiryDate = 'Pick an expiry date';
    } else {
      const chosen = new Date(allocateForm.allocationExpiryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (chosen < today) {
        errors.allocationExpiryDate = 'Expiry date cannot be in the past';
      }
    }
    setAllocateErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitAllocation = async () => {
    if (!validateAllocateForm() || !allocatePlan) return;

    const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
    const selectedVendor = localStorage.getItem('selectedVendor');
    const updatedBy = localStorage.getItem('partnerCode');

    const payload = {
      flag: 1, // 1 = allocate/update pool allocation
      partnerCode: Number(selectedPartnerCode),
      planCode: String(allocatePlan.planid),
      mappingId: Number(allocatePlan.mappingId ?? allocatePlan.id ?? 0),
      vendorId: Number(selectedVendor),
      allocatedQuantity: Number(allocateForm.allocatedQuantity),
      allocationExpiryDate: allocateForm.allocationExpiryDate,
      allocationNotes: allocateForm.allocationNotes,
      updatedBy: String(updatedBy || ''),
      targetPartnerCode: Number(allocateForm.targetPartnerCode),
    };

    setAllocating(true);
    try {
      const response = await fetch(`${apiUrl}ESIMGOPartner/UpdatePartnerPoolAllocation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.isSuccess) {
        setAllocateSuccess(true);
        setTimeout(() => {
          handleCloseAllocateModal();
        }, 1200);
      } else {
        setAllocateErrors({ form: result.message || 'Failed to allocate pool. Please try again.' });
      }
    } catch (err) {
      setAllocateErrors({ form: 'Something went wrong while allocating the pool. Please try again.' });
    } finally {
      setAllocating(false);
    }
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-5 text-red-500">{error}</div>;
  }

  return (
    <div className="mt-4 p-4 justify-between items-center bg-white">
        <div className="flex justify-between ml-4">
     <div className="p-4">
      {partner ? (
        <div className="bg-gray-100  shadow-md rounded p-4">
          <h2 className="text-xl font-bold mb-4">Partner Details</h2>
          <p><strong>Company Name:  </strong> {partner.companyname}</p>
          <p><strong>Contact Person:</strong> {partner.contactperson}</p>
          <p><strong>Partner Code:  </strong>{partner.partnercode}</p>
          <p><strong>Partner email:  </strong>{partner.email}</p>


        </div>
      ) : (
        <div>No partner found for the stored partner code.</div>
      )}
    </div>
    <div className="p-4">
      {partner ? (
        <div className="bg-gray-100  shadow-md rounded p-2">
          <h2 className="text-xl font-bold mb-4">Partner Information</h2>
      
          <p><strong>Balance:</strong> ${partner.balance}</p>
          <p><strong>Discount:</strong> {partner.discount}%</p>

          <p><strong> Type:  </strong>{partner.role}</p>

        </div>
      ) : (
        <div>No partner found for the stored partner code.</div>
      )}
    </div>
</div>
      <h1 className="text-5xl font-semibold mb-4">Available Plans</h1>
      <table className="min-w-full bg-white">
        <thead>
          <tr>
                        <th className="py-2 px-4 text-center border-b">S.No</th>
            <th className="py-2 px-4 text-center border-b">Plan Name</th>
            <th className="py-2 px-4 text-center border-b">Country</th>
            <th className="py-2 px-4 text-center border-b">Data</th>
            <th className="py-2 px-4 text-center border-b">Validity</th>
            <th className="py-2 px-4 text-center border-b">Buying Price</th>
            <th className="py-2 px-4 text-center border-b">Selling Price</th>
            <th className="py-2 px-4 text-center border-b">Plan ID</th>
            <th className="py-2 px-4 text-center border-b">Operator</th>
            <th className="py-2 px-4 text-center border-b">Price</th>
            <th className="py-2 px-4 text-center border-b">Status</th>
            <th className="py-2 px-4 text-center border-b">Pool</th>
          </tr>
        </thead>
        <tbody>
          {plans.length === 0 ? (
            <tr>
              <td colSpan="9" className="py-4 px-4 text-center text-red-500 font-semibold">
                Sorry, no plans are available or active.
              </td>
            </tr>
          ) : (
            plans.map((plan,index) => (
              <tr key={plan.planid}>
                                <td className="py-2 px-4 text-center border-b">{index + 1}</td>
                <td className="py-2 px-4 text-center border-b">{plan.planname}</td>
                <td className="py-2 px-4 text-center border-b">{plan.country}</td>
                <td className="py-2 px-4 text-center border-b">{plan.data}</td>
                <td className="py-2 px-4 text-center border-b">{plan.validity}</td>
                <td className="py-2 px-4 text-center border-b">${parseFloat(plan.buying_cost).toFixed(2)}</td>
                <td className="py-2 px-4 text-center border-b">${plan.sellingcost}</td>
                <td className="py-2 px-4 text-center border-b">{plan.planid}</td>
                <td className="py-2 px-4 text-center border-b">{plan.operatorname || 'N/A'}</td>
                <td className="py-2 px-4 text-center border-b">
                  <button
                    onClick={() => handleOpenModal(plan)}
                    className='rounded-full px-6 py-2 font-semibold text-white shadow-md hover:bg-white transition duration-200 ease-in'
                    style={{ background: 'linear-gradient(to bottom right, #27d0b6, #24c8b5, #1bb1af, #18a8ad)' }}
                  >   
                    Edit Price
                  </button>
                </td>
                <td className="py-2 px-4 text-center border-b">
                <button
                onClick={() => handleActionPlan(1, plan.planid)} // Pass the planid when removing the plan
                className='rounded-full px-6 py-2 font-semibold text-white shadow-md hover:bg-white transition duration-200 ease-in'
                style={{ background: 'linear-gradient(to bottom right, #27d0b6, #24c8b5, #1bb1af, #18a8ad)' }}
              >
                Hide Plan
              </button>
                </td>
                <td className="py-2 px-4 text-center border-b">
                  <button
                    onClick={() => handleOpenAllocateModal(plan)}
                    className="rounded-full px-6 py-2 font-semibold text-white shadow-md hover:bg-white transition duration-200 ease-in"
                    style={{ background: 'linear-gradient(to bottom right, #6366f1, #4f46e5, #4338ca, #3730a3)' }}
                  >
                    Allocate Pool
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Modal for Updating Price */}
      {showModal && selectedPlan && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <h2 className="text-2xl font-semibold mb-4">Update Price for {selectedPlan.planname}</h2>
            
            {/* Displaying all plan details */}
            <div className="mb-4">
              <p><strong>Plan Name:</strong> {selectedPlan.planname}</p>
              <p><strong>Country:</strong> {selectedPlan.country}</p>
              <p><strong>Data:</strong> {selectedPlan.data}</p>
              <p><strong>Validity:</strong> {selectedPlan.validity}</p>
              <p><strong>Buying price:</strong>${parseFloat(selectedPlan.buying_cost).toFixed(2)}</p>
              <p><strong>Selling Price:</strong> ${selectedPlan.sellingcost}</p>
              <p><strong>Plan Id</strong> {selectedPlan.planid}</p>
              <p><strong>Operator:</strong> {selectedPlan.operatorname || 'N/A'}</p>
            </div>
            
            {/* New Price Input */}
            <div className="mb-4">
              <label htmlFor="newPrice" className="block text-sm font-medium text-gray-700">
                New Price
              </label>
              <input
                type="number"
                id="newPrice"
                value={newPrice}
                onChange={(e) => setNewPrice(e.target.value)}
                className="w-full mt-2 p-2 border border-gray-300 rounded-md"
                required
              />
            </div>
            
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => handleActionPlan(2)} // Flag 2 for updating the price
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Update Price
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Pool Allocation */}
      {showAllocateModal && allocatePlan && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50 px-4"
          onClick={handleCloseAllocateModal}
        >
          <div
            className="bg-white rounded-xl w-full max-w-md shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              className="px-6 py-4 text-white"
              style={{ background: 'linear-gradient(to right, #4f46e5, #4338ca)' }}
            >
              <h2 className="text-lg font-semibold">Allocate Pool</h2>
              <p className="text-sm text-indigo-100 mt-0.5">{allocatePlan.planname} · {allocatePlan.country}</p>
            </div>

            <div className="px-6 py-5">
              {allocateSuccess ? (
                <div className="flex flex-col items-center py-6 text-center">
                  <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mb-3">
                    <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-800 font-medium">Pool allocated successfully</p>
                </div>
              ) : (
                <>
                  {allocateErrors.form && (
                    <div className="mb-4 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-600">
                      {allocateErrors.form}
                    </div>
                  )}

                  <div className="space-y-4">
                    

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Quantity to Allocate
                      </label>
                      <input
                        type="number"
                        min="1"
                        value={allocateForm.allocatedQuantity}
                        onChange={(e) => handleAllocateFieldChange('allocatedQuantity', e.target.value)}
                        placeholder="e.g. 50"
                        className={`w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                          allocateErrors.allocatedQuantity ? 'border-red-400' : 'border-gray-300'
                        }`}
                      />
                      {allocateErrors.allocatedQuantity && (
                        <p className="text-xs text-red-500 mt-1">{allocateErrors.allocatedQuantity}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Allocation Expiry Date
                      </label>
                      <input
                        type="date"
                        value={allocateForm.allocationExpiryDate}
                        onChange={(e) => handleAllocateFieldChange('allocationExpiryDate', e.target.value)}
                        className={`w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                          allocateErrors.allocationExpiryDate ? 'border-red-400' : 'border-gray-300'
                        }`}
                      />
                      {allocateErrors.allocationExpiryDate && (
                        <p className="text-xs text-red-500 mt-1">{allocateErrors.allocationExpiryDate}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Notes <span className="text-gray-400 font-normal">(optional)</span>
                      </label>
                      <textarea
                        value={allocateForm.allocationNotes}
                        onChange={(e) => handleAllocateFieldChange('allocationNotes', e.target.value)}
                        placeholder="Add context for this allocation..."
                        rows={3}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400 resize-none"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 mt-6">
                    <button
                      onClick={handleCloseAllocateModal}
                      disabled={allocating}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 disabled:opacity-50"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitAllocation}
                      disabled={allocating}
                      className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-60 flex items-center gap-2"
                    >
                      {allocating && (
                        <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24" fill="none">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                        </svg>
                      )}
                      {allocating ? 'Allocating...' : 'Allocate'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

        <div className="container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-4">Plan List</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
            <th className="px-4 py-2 border border-gray-300 text-left">Id</th>
            <th className="px-4 py-2 border border-gray-300 text-left">plan_id</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Plan Name</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Status</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Price (USD)</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Created Date</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
          {plans.length === 0 ? (
            <tr>
              <td colSpan="8" className="py-4 px-4 text-center text-red-500 font-semibold">
               Updated plans and deleted plans will be displayed here.
              </td>
            </tr>
          ) : (
           planss.map((plan) => (
              <tr key={plan.id} className="odd:bg-white even:bg-gray-50">
                 <td className="px-4 py-2 border border-gray-300">{plan.id}</td>
                 <td className="px-4 py-2 border border-gray-300">{plan.plan_id}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.plan_name}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.status}</td>
                <td className="px-4 py-2 border border-gray-300 text-blue-500">${plan.price}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.createddate}</td>
                <td className="px-4 py-2 border border-gray-300">
              <button
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  onClick={() => handledelete(plan.id)} // Pass the dynamic plan.id
                  disabled={loading}
              >
                  {loading ? 'Loading...' : 'Revoke '}
              </button>
          </td>

            </tr>
          ))
        )}
          </tbody>
        </table>
      </div>
    </div>
    </div>

  );
};

export default PlansList;